module.exports = __webpack_public_path__ + "resources/img/img_rancher2.fbdfe2647b6415385e14bc174b31b07d.png";